import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Main.module.scss";
import StateContext from "../../context/state";
import PathContext from "../../context/path";
import Footer from '../../components/Footer';
import Cover from '../../components/Cover';
import Header from '../../components/Header/Header';
import TestQuestion from '../../components/TestQuestion';
import Grade from '../../components/Grade';
import TestResult from '../../components/TestResult';
const Main = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const refCoopBtn = useRef(null);
  const refCoop = useRef(null);
  const { updatePopupOpen, isMobile } = state;
  useEffect(() => {
    const coop = refCoop.current;
    const coopBtn = refCoopBtn.current;
    if (isMobile) return;
    const addHover = () => {
      coop.classList.add(styles.hover);
    }
    const removeHover = () => {
      coop.classList.remove(styles.hover);
    }
    coopBtn.addEventListener('mouseover', addHover);
    coopBtn.addEventListener('mouseout', removeHover);
    return () => {
      coop.classList.remove(styles.hover);
      coopBtn.removeEventListener('mouseover', addHover);
      coopBtn.removeEventListener('mouseout', removeHover);
    }
  }, [isMobile]);

  return (
    <>
      <div className={styles.wrap}>
        <div className={styles.header}>
          <Header />
        </div>
        <main className={styles.main}>
          <Cover />
          <div className={styles.task}>
            <div className={styles.point}>
              Задача
            </div>
            <div className={`${styles.task__text} ${styles.h3}`}>
              Переработать стандарты коммуникации «Северстали» в понятный цифровой проект, с которым сотрудникам будет удобно взаимодействовать
            </div>
            <a href="https://digital.infografika.agency/severstal-commrules/" target="_blank" rel="noopener noreferrer" className={`${styles.task__link} ${styles.link}`}>
              <span>Посмотреть проект</span>
              <div className={styles.link__icon}>
                <img src={`${path}/img/link-icon.svg`} alt="" />
              </div>
            </a>
          </div>
          <div className={styles.container}>
            <div className={styles.done}>
              <div className={styles.point}>
                Что сделали
              </div>
              <div className={`${styles.done__text} ${styles.h3}`}>Превратили 13 листов коммуникационного стандарта в понятные схемы и шаблоны, по которым удобно составлять письма и готовиться ко встречам.</div>
              <div className={styles.done__test}>
                <TestQuestion questionIndex={0}>
                  <>Зачем на это тратить деньги? Регламент написан. Зачем переделывать?</>
                  <>
                    <p>Важно понимать, что контент для внутренних коммуникаций — это инвестиции в корпоративную культуру, комфорт сотрудников. Грамотная коммуникация с сотрудниками снижает текучесть кадров и повышает лояльность. </p>
                    <p>Когда компания покупает сотруднику новый ортопедический стул, она не задумывается о том, принесёт ли этот стул деньги. Его покупают, чтобы сотруднику было комфортнее проводить 8 часов на рабочем месте, чтобы сотрудник был счастливее и лучше закрывал проекты. </p>
                    <p>С внутренними проектами то же самое. Понятный лендинг с регламентами не принесёт компании денег напрямую. Но он облегчит жизнь сотрудникам. И они с большей радостью будут работать на благо компании.</p>
                  </>
                </TestQuestion>
              </div>
            </div>
            <div className={styles.stage}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <div className={styles.point}>
                    Этап 0
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.h3}>Формулирование задачи</div>
                  <div className={styles.stage__text}>
                    Северсталь — крупнейшее сталелитейное производство в России. В компании более 50 000 сотрудников. Чтобы весь этот механизм работал слаженно, компания регулярно обновляет стандарты общения. В регламентах зафиксированы все возможные форматы коммуникации, но эти документы слишком объёмные для регулярного использования.
                  </div>
                  <div className={styles.stage__test}>
                    <TestQuestion questionIndex={1}>
                      <>Мы бы хотели подобный проект, но не можем придумать как он должен выглядеть. Отдать агентству — страшно. Где гарантия, что результат нам понравится?</>
                      <>
                        <p>Результат не будет неожиданностью для клиента, если работать итерациями. Мы делим проект на несколько частей, и каждую из них согласовываем.</p>
                        <p>Сделали подход по концепту и стилю коммуникации — согласовали. <br /> Собрали структуру — согласовали.<br /> Разработали прототип — согласовали.<br /> Сделали подход к дизайну — согласовали.</p>
                        <p>Так клиент всегда знает, что происходит на их проекте, и может оперативно давать обратную связь.</p>
                      </>
                    </TestQuestion>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.stage}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <div className={styles.point}>
                    Этап 1
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.h3}>Структура</div>
                  <div className={styles.stage__text}>
                    <p>У «Северстали» есть хороший стандарт коммуникации. В нем раскрыты все возможные форматы взаимодействия внутри компании, но он довольно объёмный и не подходит для регулярного использования. Поэтому работу мы начали с того, что пересобрали структуру — сделали её нативной, удобной для быстрой подготовки ко встречам или звонкам. </p>
                    <p>В основу проекта заложили идею простоты. Как на уровне структуры — без множества вкладок, дополнительных страниц и ненужных декоративных элементов. Так и на уровне языка — чтобы быть понятными как менеджерам отделов, так и тем, кто работает в цехах. Поэтому язык мы сделали взрослым, но не слишком формализованным, простым и комфортным.</p>
                    <p>На главный экран вынесли принципы коммуникации в компании — правила, без которых невозможно комфортное общение. Основную часть лендинга поделили на 4 равные части, по 4 типам коммуникации внутри «Северстали»: письма, звонки, встречи и рассылки.</p>
                  </div>
                </div>
              </div>

              <div className={styles.image}>
                <picture>
                  <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-1-mobile.webp`} />
                  <img src={`${path}/img/case-img-1.webp`} alt="" />
                </picture>
                <div className={styles.caption}>Язык сделали простым для восприятия, чтобы быть <br /> понятными для всех, вне зависимости от профессии.</div>
              </div>

              <div className={styles.blocks}>
                <div className={`${styles.row} ${styles.row_reverse}`}>
                  <div className={styles.col}>
                    <span>Было</span>
                    <div className={`${styles.block} ${styles.block_image}`}>
                      <picture>
                        <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-10-mobile.webp`} />
                        <img src={`${path}/img/case-img-10.webp`} alt="" />
                      </picture>
                    </div>
                  </div>
                  <div className={styles.col}>
                    <span>Стало</span>
                    
                    <div className={`${styles.block} ${styles.block_image}`}>
                      <picture>
                        <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-11-mobile.webp`} />
                        <img src={`${path}/img/case-img-11.webp`} alt="" />
                      </picture>
                    </div>
                    <div className={styles.caption}>Для удобства сотрудников, мы собрали структуру не по направлениям регламентов, а по форматам коммуникации: писать, <br /> звонить, читать, выступать.</div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <div className={styles.quote}>
            <div className={`${styles.quote__text} ${styles.h3}`}>Стандарт — это документ, который лежит на полке или в корпоративном облаке. Лендинг — это инструмент, которым регулярно пользуются</div>
          </div>

          <div className={styles.container}>
            <div className={`${styles.stage} ${styles.stage_2}`}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <div className={styles.point}>
                    Этап 2
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.h3}>Контент</div>
                  <div className={styles.stage__text}>
                    <p>Лучший способ упростить информацию — визуализировать. Базовые требования ко встречам мы оформили по референсам клиента. Но нам показалось этого мало, поэтому мы перевели большую часть текста стандартов в схемы и шаблоны. То, что не смогли визуализировать, оформили в чек-листы или упростили, сократили и вынесли в поп-апы.</p>
                    <p>Несколько страниц правил и замечаний превратили в примеры: на шаблоне письма и скрипте звонка показали, на что стоит обратить внимание при общении с коллегами.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={styles.blocks}>
              <div className={`${styles.row}`}>
                <div className={styles.col}>
                  <span>Было</span>
                  
                  <div className={`${styles.block} ${styles.block_image}`}>
                      <picture>
                        <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-12-mobile.webp`} />
                        <img src={`${path}/img/case-img-12.webp`} alt="" />
                      </picture>
                    </div>
                </div>
                <div className={styles.col}>
                  <span>Стало</span>
                  <div className={`${styles.block} ${styles.block_image}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-2-mobile.webp`} />
                      <img src={`${path}/img/case-img-2.webp`} alt="" />
                    </picture>
                  </div>
                  <div className={styles.caption}>Наглядно показали базовые требования <br /> к оформлению писем.</div>
                </div>
              </div>
            </div>


            <div className={styles.image}>
              <picture>
                <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-3-mobile.webp`} />
                <img src={`${path}/img/case-img-3.webp`} alt="" />
              </picture>
              <div className={styles.caption}>В поп-апы выносили только важный для клиента контент. <br /> Не ложится в основную канву текста?<br /> Упрощаем и выносим в поп-ап.</div>
            </div>

            <div className={styles.blocks}>
              <div className={`${styles.row}`}>
                <div className={styles.col}>
                  <span>Было</span>
                  <div className={`${styles.block} ${styles.block_image}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-4-mobile.webp`} />
                      <img src={`${path}/img/case-img-4.webp`} alt="" />
                    </picture>
                  </div>
                </div>
                <div className={styles.col}>
                  <span>Стало</span>
                  <div className={`${styles.block} ${styles.block_image}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-5-mobile.webp`} />
                      <img src={`${path}/img/case-img-5.webp`} alt="" />
                    </picture>
                  </div>
                  <div className={styles.caption}>Сотрудники «Северстали» забывали фиксировать цели<br /> переписки, поэтому мы сделали акцент на этом пункте.</div>
                </div>
              </div>
            </div>

            <div className={styles.blocks}>
              <div className={`${styles.row}`}>
                <div className={styles.col}>
                  <span>Было</span>
                  <div className={`${styles.block} ${styles.block_image}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-6-mobile.webp`} />
                      <img src={`${path}/img/case-img-6.webp`} alt="" />
                    </picture>
                  </div>
                </div>
                <div className={styles.col}>
                  <span>Стало</span>
                  <div className={`${styles.block} ${styles.block_image}  ${styles.block_noborder}`}>
                    <picture>
                      <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-7-mobile.webp`} />
                      <img src={`${path}/img/case-img-7.webp`} alt="" />
                    </picture>
                  </div>
                  <div className={styles.caption}>Подчеркнули, что нужно здороваться друг с другом, <br /> говорить чётко и по делу, и не звонить ради звонка..</div>
                </div>
              </div>
            </div>

            <div className={styles.image}>
              <picture>
                <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-8-mobile.webp`} />
                <img src={`${path}/img/case-img-8.webp`} alt="" />
              </picture>
              <div className={styles.caption}>Из рекомендаций ко встречам собрали чек-листы <br /> для участников и организаторов встреч. Выполнил<br /> все пункты — получил отметку «Хорошего сотрудника».</div>
            </div>

            <div className={`${styles.row} ${styles.row_8}`}>
              <div className={styles.col}>
              </div>
              <div className={styles.col}>
                <div className={styles.stage__test}>
                  <TestQuestion questionIndex={2}>
                    <>Как человек со стороны может почувствовать вайб компании? Без этого внутренний проект не сработает.</>
                    <>
                      <p>Только задавая вопросы. Много вопросов. Например, на брифингах мы часто спрашиваем у клиентов: какое настроение должна считать ЦА или какие ассоциации должны у неё появится. Это помогает раскопать истинные настроения внутри компании, а не только те, что зафиксированы в регламентах. </p>
                      <p>Перед тем, как писать проект, мы согласовываем с клиентом пробы по смыслам и тональности текста. Это как финальный тест на «попадание в вайб компании».</p>
                    </>
                  </TestQuestion>
                </div>
              </div>
            </div>

            <div className={styles.stage}>
              <div className={styles.row}>
                <div className={styles.col}>
                  <div className={styles.point}>
                    Этап 3
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.h3}>Дизайн</div>
                  <div className={styles.stage__text}>
                    <p>Брендбук «Северстали» — одно из лучших руководств, с которым мы работали. И мы чётко ему следовали. Внутри описаны все правила и сценарии использования элементов. На нашей стороне была компоновка блоков и работа с текстом. </p>
                    <p>Как и всем проектом, дизайном движет простота и сдержанная строгость: тонкие обводки, рубленные прямые формы, цветовая триада с красными акцентами.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className={`${styles.image} ${styles.image_border}`}>
              <picture>
                <source media="(max-width: 767px)" srcSet={`${path}/img/case-img-9-mobile.webp`} />
                <img src={`${path}/img/case-img-9.webp`} alt="" />
              </picture>
            </div>

            <div className={`${styles.row} ${styles.row_10}`}>
              <div className={styles.col}>
              </div>
              <div className={styles.col}>
                <div className={styles.stage__test}>
                  <TestQuestion questionIndex={3}>
                    <>А как можно измерить эффективность таких проектов?</>
                    <>
                      <p>Контент для внутренних коммуникаций работает как контент-маркетинг: аккуратно наращиваешь лояльность через комфортный контент, а потом собираешь плоды этой лояльности. </p>
                      <p>Оценивают проекты для внутренних коммуникаций так же, как контент-маркетинг — по ключевым метрикам контента: время и глубина просмотра, количество посетителей. </p>
                      <p>Если контент чем‑то помогает сотрудников, а может просто радует их — показатели высокие. Значит, мы сделали рабочий проект. Внутрикомы также могут оценивать влияние контента через eNPS — повысился ли уровень лояльности внутри компании. А можно просто проводить опросы и напрямую спрашивать сотрудников, насколько контент помогает им в работе.</p>
                    </>
                  </TestQuestion>
                </div>
              </div>
            </div>

          </div>
          <div className={`${styles.quote} ${styles.quote_result}`}>
            <div className={styles.point}>
              Результаты
            </div>
            <div className={`${styles.quote__text} ${styles.h3}`}>Проект только запущен. Поэтому ещё рано оценивать его на основе конкретных метрик. Но можно оценить на соответствие поставленной задачи:</div>
            <div className={`${styles.quote__text} ${styles.quote__text_point}  ${styles.h3}`}><span>Упростить</span>  внутренний коммуникационный стандарт компании.</div>
            <div className={`${styles.quote__text} ${styles.quote__text_point} ${styles.h3}`}><span>Превратить</span> его в понятный инструмент для сотрудников.</div>
            <div className={`${styles.quote__text} ${styles.h3}`}>13 страниц регламента → несколько схем и шаблонов.</div>
          </div>

          <Grade />

          <div className={styles.container}>
            <div className={`${styles.row} ${styles.row_11}`}>
              <div className={styles.col}>
                <div className={styles.point}>
                  Результаты опроса
                </div>
              </div>
              <div className={styles.col}>
                <div className={styles.h3}>А теперь подведём итоги</div>
                <div className={styles.stage__test}>
                  <TestResult />
                </div>
              </div>
            </div>

            <div className={styles.more}>
              <h2 className={styles.more__title}>
                мы <span></span><div>ещё</div> <div>сделали</div>

              </h2>

              <div className={styles.more__icon}>
                <img src={`${path}/img/more-icon.svg`} alt="" />
              </div>
              <div className={styles.more__text}>За 12 лет работы агентства мы сделали более 350 коммуникационных проектов</div>
              <div className={styles.row}>
                <div className={styles.col}>
                  <a href='https://www.infografika.agency/cases/gpb-svet' className={styles.more__card}>
                    <div className={`${styles.more__card_img} ${styles.more__card_img_blue}`}>
                      <img src={`${path}/img/more-img-1.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={`${styles.h3}`}>Lifestyle-портал для сотрудников</div>
                        <div className={styles.more__card_comp}>Газпромбанк</div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
                <div className={styles.col}>
                  <a href='https://www.infografika.agency/cases/karta-poiskovyh-zaprosov' className={styles.more__card}>
                    <div className={`${styles.more__card_img} ${styles.more__card_img_grey}`}>
                      <img src={`${path}/img/more-img-2.webp`} alt="" />
                    </div>
                    <div className={styles.more__card_body}>
                      <div className={styles.more__card_info}>
                        <div className={`${styles.h3}`}>Карта поисковых запросов</div>
                        <div className={styles.more__card_comp}>Semrush</div>
                      </div>
                      <div className={styles.more__card_icon}>
                        <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="25" cy="25" r="24" fill="black" stroke="black" strokeWidth="2" />
                          <path d="M18.632 13V15.244H32.184L13 34.472L14.672 36.144L33.9 16.96V30.512H36.144V13H18.632Z" fill="white" />
                        </svg>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>


          </div>
          <div className={styles.cooperate} ref={refCoop}>
            <div className={styles.point}>
              Сотрудничать
            </div>
            <div className={`${styles.cooperate__text} `}>Напишите нам! Мы предложим решение для вашей задачи и подберём референсы</div>
            <div className={styles.cooperate__footer}>
              <span>1 млн — с нуля до рабочего продукта. <br />Финальная смета зависит от объёма контента, <br /> сложности механик и формата</span>
              <div className={styles.cooperate__btn} ref={refCoopBtn} onClick={() => updatePopupOpen(true)}>Написать</div>

            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );

}

export default Main;
